import Github from './github.svg';
import Mail from './mail.svg';
import LinkedIn from './linkedin.svg';

export { Github, Mail, LinkedIn };
